import { environment } from '../../environments/environment';

const apiPrefixes = [
  '/transaction/',
  '/iso/',
  '/gp-query/',
  '/management/',
  '/client/',
  '/sftp/',
  '/reconciliation/'
];

export function apiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const baseUrl = environment.apiBaseUrl.replace(/\/$/, '');

  return `${baseUrl}${normalizedPath}`;
}

export function isApiUrl(url: string): boolean {
  if (apiPrefixes.some(prefix => url.startsWith(prefix))) {
    return true;
  }

  if (!environment.apiBaseUrl) {
    return false;
  }

  return apiPrefixes.some(prefix => url.startsWith(apiUrl(prefix)));
}
